<img alt="trash" src="assets/images/svgs/trash.svg" />
